import BackToTop from 'components/BackToTop';
import Header from 'components/Header';
import Footer from 'components/Footer';
import ScrollWrapper from 'components/ScrollWrapper';

const AppShell = ({ children, pathname }) => (
  <ScrollWrapper path={pathname} viewClassName="view">
    <Header path={pathname} />
    <main className="main-content">
      <div className="main-content__wrap">{children}</div>
    </main>
    <Footer />
    <BackToTop />
  </ScrollWrapper>
);

export default AppShell;
